import { useEffect, useState } from 'react'

import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import dsa from '../../assets/images/DSA.png'

import './MyWork.scss'
import { Link } from 'react-router-dom'

const MyWork = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container mywork-page">
        <div className="text-zone text-center">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                'U',
                'p',
                'd',
                'a',
                't',
                'i',
                'n',
                'g',
                ' ',
                'S',
                'o',
                'o',
                'n',
                ' . ',
                ' . ',
                '.',
              ]}
              idx={15}
            />
          </h1>
          <Link
            to={`https://frontend-dsa.netlify.app/`}
            target="_blank"
            className="text-center"
          >
            <h1 className="removeEffecct">Project - 01</h1>
            <img className="imgcls" src={dsa} alt="project 1" />
            <h2>
              Frontend DSA Solutions - Contains important DSA concept along with
              the Solution explanation
            </h2>
          </Link>
        </div>
      </div>
      <Loader type="line-scale" />
    </>
  )
}

export default MyWork
